const jutil = window.jutil = {
  mayUseStorage: function() {
    try {
      localStorage.use_storage = 1;

      return true;
    } catch (e) {
      return false;
    }
  },

  elementInViewport: function(myElement) {
    var bounding = myElement.getBoundingClientRect();
    var myElementHeight = myElement.offsetHeight;
    var myElementWidth = myElement.offsetWidth;

    return bounding.top >= -myElementHeight
      && bounding.left >= -myElementWidth
      && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth
      && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight;
  },

  // -- Bind checkboxes
  bindCheckboxes: function($parent) {
    if ($parent) {
      var $checkboxes = $parent.find('input[data-checkbox][type="checkbox"]');
    }
    else {
      var $checkboxes = $('input[data-checkbox][type="checkbox"]');
    }

    if ($checkboxes.length) {
      $checkboxes.each(function() {
        var $fakeCheckbox = $('[data-checkbox="' + $(this).data('checkbox') + '"]:not(input)');

        $(this).on('change', function() {
          if ($(this).prop('checked')) {
            $fakeCheckbox.addClass('form__checkbox-fake--checked');
          }
          else {
            $fakeCheckbox.removeClass('form__checkbox-fake--checked');
          }
        });
      });
    }
  },

  // -- Bind datepickers
  bindDatepickers: function($parent) {
    let $datepickers;
    if ($parent) {
      $datepickers = $parent.find('[data-js-hook="pickadate"]');
    }
    else {
      $datepickers = $('[data-js-hook="pickadate"]');
    }

    if ($datepickers.length) {
      $datepickers.each(function() {
        let $datepicker = $(this);
        let $label = $('label[for="' + $datepicker.attr('id') + '"]');
        $datepicker.on('mousedown', function(e) {
          e.preventDefault();
        }).pickadate({
          format: 'mmm d, yyyy',
          disable: [
            {from: [0, 0, 0], to: new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24)}
          ],
          onRender: function() {
            this.$root.find('.picker__frame').addClass('picker__frame--premium');
            $datepicker.removeAttr('aria-expanded');
            $($(this)[0].$root[0]).find('[aria-activedescendant]').removeAttr('aria-activedescendant');
          },
          onSet: function(context) {
            if (typeof context.select != 'undefined') {
              $label.addClass('active');
            }
            else {
              $label.removeClass('active');
            }
          },
          onOpen: function() {
            $label.addClass('focus');
          },
          onClose: function() {
            this.$holder.blur();
            $label.removeClass('focus');
          }
        });
      });
    }
  },

  // -- Bind infield form labels
  bindInfieldLabels: function($parent) {
    if ($parent) {
      var $labels = $parent.find('[data-infield-label]');
    }
    else {
      var $labels = $('[data-infield-label]');
    }

    if ($labels.length) {
      $labels.each(function() {
        var self = $(this);
        var target = $(this).attr('for');
        var input = $('#' + target);
        if (input.val()) {
          self.addClass('active');
        }
        input.on('focus', function() {
          if (!$(this).val()) {
            self.addClass('focus');
          }
        });
        input.on('keyup input', function() {
          if ($(this).val()) {
            self.removeClass('focus');
            self.addClass('active');
          }
          else {
            self.removeClass('active');
            self.addClass('focus');
          }
        });
        input.on('blur', function() {
          if (!$(this).val()) {
            self.removeClass('focus');
          }
        });
      });
    }
  },

  bindFancybox: function($parent) {
    let $triggers = $('[data-fancybox],[target="video"],[target="embed"],[target="popup"]');

    if ($parent) {
      $triggers = $parent.find('[data-fancybox],[target="video"],[target="embed"],[target="popup"]');
    }

    $triggers.each(function() {
      let url = $(this).attr('href');
      let target = $(this).attr('target');
      let wistia = url.match(/wistia/);

      if (target == 'embed' || wistia) {
        $(this).attr('data-type', 'iframe');

        if (!$(this).attr('data-src')) {
          $(this).attr('data-src', url).attr('href', 'javascript:void(0)');
        }
      }

      if (wistia) {
        $(this).data('as-video', 1);
      }
    });

    $triggers.fancybox({
      idleTime: 60,
      loop: true,
      transitionEffect: "slide",

      buttons: [
        "close"
      ],

      wheel: false,

      beforeLoad: function() {
        $('.fancybox-container').css('z-index', maxZ() + 1);
      },

      beforeShow: function(instance) {
        var $trigger = instance.group[instance.currIndex].opts.$orig;

        if ($trigger.data('as-video')) {
          instance.$refs.stage.addClass('video');
        }
      }
    });
  },


  bindModal: function(options) {
    var self = this;

    options = $.extend({
      $toggle: $('[data-modal-open]'),
      $modal: $('[data-modal-id]'),
      staticZ: false,
      on: {
        open: null,
        beforeOpen: null,
        close: null,
        beforeClose: null
      }
    }, options);

    options.$modal
      .on('modal-event', function(e, name, data) {
        var event = options.on[name];

        if (event) {
          event();
        }
      })
      .on('open', function(e, trigger) {
        if (!$(this).data('open')) {
          options.$modal.trigger('modal-event', ['beforeOpen', {trigger: trigger}]);

          $(this).fadeIn(200, function() {
            options.$modal.trigger('modal-event', ['open', {trigger: trigger}]);
          });

          if (typeof $(this).attr('data-modal-lock') == 'undefined' || $(this).data('modal-lock') === true) {
            self.lockBody();
          }

          if (options.staticZ) {
            if (!$(this).data('z-index')) {
              $(this).data('z-index', maxZ() + 1);
            }
          }
          else {
            $(this).data('z-index', maxZ() + 1);
          }

          $(this).css('z-index', $(this).data('z-index'));

          $(this).data('open', true);
        }

        if (!$(this).data('bound-ui')) {
          $(this).data('bound-ui', true);

          $(this).find('[data-modal-close]').click(function(e) {
            e.preventDefault();

            $(this).trigger('close');
          });

          $(this).click(function(e) {
            var $parentContent = $(e.target).parents().filter('[data-modal-content]');

            if (!$parentContent.length) {
              $(this).trigger('close');
            }
          });
        }
      })
      .on('close', function() {
        if ($(this).data('open')) {
          options.$modal.trigger('modal-event', ['beforeClose']);

          $(this).fadeOut(200, function() {
            options.$modal.trigger('modal-event', ['close']);
            $(this).css('z-index', '');
          });

          if (typeof $(this).attr('data-modal-lock') == 'undefined' || $(this).data('modal-lock') === true) {
            self.releaseBody();
          }

          $(this).data('open', false);
        }
      });

    $(document).keyup(function(e) {
      if (e.key === "Escape") {
        options.$modal.trigger('close');
      }
    });

    if (options.$toggle && options.$toggle.length) {
      options.$toggle.click(function(e) {
        e.preventDefault();

        if (!$(this).data('modal')) {
          $(this).data('modal', options.$modal.filter('[data-modal-id="' + $(this).data('modal-open') + '"]'));
        }

        if ($(this).data('modal').length) {
          $(this).data('modal').trigger('open', [$(this)]);
        }
      });
    }
  },

  bindForms: function($parent) {
    let $forms = $parent ? $parent.find('[data-form-initiator]') : $('[data-form-initiator]');

    if ($forms.length) {
      $forms.each(function() {
        let initator = $(this).data('form-initiator');
        let initparts = initator.split(/\./);

        if (initparts.length) {
          let pointer = window;

          for (let i = 0; i < initparts.length; i++) {
            let part = initparts[i];

            if (typeof pointer[part.trim()] !== 'undefined') {
              pointer = pointer[part.trim()];
            }
          }

          if (typeof pointer === 'function') {
            pointer($(this));
          }
        }
      });
    }
  },

  // -- Bind contact form
  bindContactForm: function($form) {
    var self = jutil;
    var $loader = $form.find('#form-loading');

    var requiredFields = [];
    var $requiredFields = $form.find('[data-field-required]');

    if ($requiredFields.length) {
      $requiredFields.each(function() {
        requiredFields.push($(this).find('input,textarea,select').attr('name'));

        var $select = $(this).find('select');
        var $label = $(this).find('label');

        if ($select.length) {
          $select.on('change', function() {
            if (!$(this).val()) {
              $label.show();
            }
            else {
              $label.hide();
            }
          });

          if ($select.val()) {
            $label.hide();
          }
        }
      });
    }

    jutil.bindDatepickers($form);

    $form.formulateNC({
      require: requiredFields.join(', '),
      errorClass: 'error',
      errorParent: '[data-field-required]',
      showOnSubmit: '#contact-confirm',
      inlineMsg: true,
      inlineMsgClass: 'form__inline-error',
      errorMsgContainer: '[data-form-error]',

      fireOnSubmit: function() {
        $(this).trigger('hide-error-message');

        $loader.fadeIn(200);
      },

      fireOnSuccess: function() {
        Jonahlytics.event.formSubmit('contact-form');

        $loader.fadeOut(200);

        cmg_google_conversion($('#contact_us_conversion').val(), $('#contact_us_conversion_id').val(), $('#contact_us_conversion_html').val());

        self.replaceFormConfirmMessageVariables($(this), $('#contact-confirm'));
        console.log('success');
      },

      fireOnError: function() {
        $loader.fadeOut(200);

        $(document).find('.form__field--error').parents('[data-field-required]').addClass('form__column--error');
        $(document).find('.form__field--error').siblings('[data-infield-label]').addClass('form__label--error');
      },

      fireOnPostError: function() {
        $(this).trigger('show-error-message', jcms.genericFormError);
      }
    });
  },

  // -- Bind tour form
  bindTourForm: function($form) {
    var self = jutil;
    var $loader = $form.find('#form-loading')

    var requiredFields = [];
    var $requiredFields = $form.find('[data-field-required]');

    if ($requiredFields.length) {
      $requiredFields.each(function() {
        requiredFields.push($(this).find('input,textarea,select').attr('name'));

        var $select = $(this).find('select');
        var $label = $(this).find('label');

        if ($select.length) {
          $select.on('change', function() {
            if (!$(this).val()) {
              $label.show();
            }
            else {
              $label.hide();
            }
          });

          if ($select.val()) {
            $label.hide();
          }
        }
      });
    }

    jutil.bindDatepickers($form);

    $form.formulateNC({
      require: requiredFields.join(','),
      errorClass: 'error',
      errorParent: '[data-field-required]',
      showOnSubmit: '#tour-confirm',
      inlineMsg: true,
      inlineMsgClass: 'form__inline-error',
      errorMsgContainer: '[data-form-error]',

      fireOnSubmit: function() {
        $(this).trigger('hide-error-message');
        $loader.fadeIn(200);
      },

      fireOnSuccess: function() {
        Jonahlytics.event.formSubmit('tour-form');

        $loader.fadeOut(200);
        cmg_google_conversion($('#schedule_tour_conversion').val(), $('#schedule_tour_conversion_id').val(), $('#schedule_tour_conversion_html').val());
        self.replaceFormConfirmMessageVariables($(this), $('#tour-confirm'));
      },

      fireOnError: function() {
        $loader.fadeOut(200);
      },

      fireOnPostError: function() {
        $(this).trigger('show-error-message', jcms.genericFormError);
      }
    });
  },

  // -- Replace form confirmation data
  replaceFormConfirmMessageVariables: function($form, $confirmation) {
    if ($form.length) {
      var formData = serializedArrayToObject($form.serializeArray());

      if ($confirmation.length) {
        $confirmation.children().each(function() {
          var $child = $(this);
          var text = $child.text();
          var varReplace;

          if (!$child.data('original-content')) {
            $child.data('original-content', text);
          }

          text = $child.data('original-content');

          if (varReplace = text.match(/\{(.*?)\}/gi)) {
            for (i = 0; i < varReplace.length; i++) {
              var replace = varReplace[i];
              var varName = replace.replace(/^\{|\}$/gi, '').replace(/(^|\-|\_)([a-z])/g, function(g) { return g.toUpperCase(); }).replace(/\-|\_/g, '');

              if (typeof formData[varName] != 'undefined') {
                text = text.replace(replace, formData[varName]);
              }
            }
          }

          $child.text(text);
        });
      }
    }
  },

  lockBody: function() {
    $('body').data('original-scrolltop', $(window).scrollTop()).css({
      position: 'fixed',
      top: ($(window).scrollTop() * -1) + 'px',
      left: 0,
      width: '100%'
    });
  },

  releaseBody: function() {
    $('body').css({
      position: '',
      top: '',
      left: '',
      width: ''
    });

    $(window).scrollTop($('body').data('original-scrolltop'));
  },

  location: {
    current: window.location.pathname.substr(1) ? window.location.pathname.substr(1).replace(/\/$/, '') : 'index',
    root: window.location.pathname.split('/')[1],
    queryString: window.location.search,

    isRoot: function(root) {
      return root.replace(/(\/$|^\/)/g, '') === this.root;
    },

    isPage: function(current) {
      return current.replace(/(\/$|^\/)/g, '') === this.current;
    },

    getQueryString: function(string) {
      if (!window.location.search) {
        return false;
      }

      if (string) {
        var query = this.queryString;
      }
      else {
        var query = [];
        this.queryString.replace(/(^\?)/, '').split('&').forEach(function(param) {
          param = param.split('=');
          query[decodeURIComponent(param[0])] = decodeURIComponent(param[1]);
        });
      }
      return query;
    },

    getParam: function(param) {
      var queries = this.getQueryString();
      param = param.trim();
      return (param && queries && queries[param]) ? queries[param] : false;
    }
  },

  dom: {
    watch: function(callback, settings = {}) {
      var observerTimeout;
      var mutationList = [];
      var settings = $.extend(
        {
          el: 'body',

          additionsOnly: true,

          filterChildless: true,

          observerTimeout: 500,

          mutationOptions: {
            attributes: false,
            childList: true,
            subtree: true
          }
        },
        settings
      );

      var observer = new MutationObserver(function(list) {
        if (observerTimeout) {
          clearTimeout(observerTimeout);

          if (list && list.length) {
            mutationList = mutationList.concat(list);
          }
        }

        observerTimeout = setTimeout(function() {
          var returnList = [];

          for (var i = 0; i < mutationList.length; ++i) {
            var mutationRecord = mutationList[i];

            if (settings.additionsOnly) {
              if (mutationRecord.addedNodes && mutationRecord.addedNodes.length) {
                mutationRecord.addedNodes.forEach(function(node) {
                  var $el = $(node);

                  if (settings.filterChildless) {
                    if ($el.length && $el.children().length) {
                      returnList.push($el);
                    }
                  }
                  else {
                    returnList.push($el);
                  }
                });
              }
            }
            else {
              var $el = $(mutationRecord.target);

              if (settings.filterChildless) {
                if ($el.length && $el.children().length) {
                  returnList.push($el);
                }
              }
              else {
                returnList.push($el);
              }
            }
          }

          if (callback) {
            callback(returnList);
          }

          mutationList = [];
        }, settings.observerTimeout);
      });

      observer.observe($(settings.el).get(0), settings.mutationOptions);
    },

    watchEl: function(callback, settings = {}) {
      this.watch(function(els) {
        if (els && els.length) {
          for (i = 0; i < els.length; i++) {
            if (callback) {
              callback(els[i]);
            }
          }
        }
      }, settings);
    }
  }
}
